import { referentialApiConnector } from 'apiConnector/secondary-market/referentialApiConnector';
import { DominoError } from 'apiConnector/secondary-market/reports';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { HttpError } from 'utils/http/httpClient.model';

import { limitOrderInputFormActions } from '../../../state/secondaryMarket/limit-order/form/input/inputForm.actions';
import { getTabRemoved$ } from '../utils';

export function fetchLimitOrderInteractionCustodianEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getSettlementTypes } = referentialApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_CUSTODIAN_RELATED_FETCH_REQUESTED'),
      mergeMap(({ tabId, bcsProductKey, client, custodianBdrId }) =>
        getSettlementTypes(bcsProductKey, client, custodianBdrId).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => limitOrderInputFormActions.custodianReceived(tabId, data)),
          catchError((err: HttpError<DominoError>) =>
            of(limitOrderInputFormActions.custodianRequestFailed(tabId, err.payload?.message)),
          ),
        ),
      ),
    );
  };
}
